import { useQuery } from '@apollo/client';
import { GET_ME } from '../queries/getMe';

/**
 * Who gets the /leadership page: Partner Leadership plus Partner Membership Officers
 * (the "supervisor" role), who also author the organisation's updates and prayer requests.
 *
 * Mirrors `canAccessLeadership` in backend/src/graphql/utils/leadership.ts — the server is
 * the real gate, this just decides what to render. Deliberately excludes plain org admins.
 */
export const useCanAccessLeadership = () => {
  const { data, loading, error } = useQuery(GET_ME);
  if (loading || error) return false;
  const membership = data?.me?.organisation?.membership;
  return (membership?.isPartnerLeadership ?? false) || (membership?.isPartnerMembershipOfficer ?? false);
};

/** The working organisation's name, used to brand its announcements (e.g. "SWBC Updates"). */
export const useOrganisationName = (): string | null => {
  const { data, loading, error } = useQuery(GET_ME);
  if (loading || error) return null;
  return data?.me?.organisation?.name ?? null;
};
